import React from 'react';
// data
import Data from '../../../../model/Data';
import { links } from '../../data.json';
// styles
import './Info.css'

interface Props {
  className?: string;
}

class Info extends React.Component<Props> {
  render(): JSX.Element {
    return (
      <div className="about-info">
        <div className="about-info__team">
          <div className="container">
          <div className="about-info__team__teams">
            <div className="about-info__team__teams-header">Учи.Team — это &gt; 750 человек, сильные продуктовые и&nbsp;контентные команды:</div>
            <ul className="about-info__team__teams-list teams">
              <li className="teams__item">Frontend, Backend, FullStack&#8209;разработчики</li>
              <li className="teams__item">Product&#8209;менеджеры</li>
              <li className="teams__item">Product- и&nbsp;бизнес&#8209;аналитики</li>
              <li className="teams__item">UX/UI&#8209;дизайнеры</li>
              <li className="teams__item">UX&#8209;исследователи</li>
              <li className="teams__item">Методисты и&nbsp;педагоги</li>
            </ul>
          </div>
            <div className="about-info__team-text">
              <a href={links.dividedTeams}>Разделение на&nbsp;продуктовые команды</a>
              <span> помогает нам одновременно развивать сразу несколько сервисов, </span>
              <a href={links.creatNew}>создавать новые</a>
              <span> и </span>
              <a href={links.experiments}>экспериментировать</a>
              <span>, а регулярные </span>
              <a href={links.userInterviews}>пользовательские интервью</a>
              <span> — делать платформу удобнее.</span>
            </div>
          </div>
        </div>
        <div className="about-info__users">
          <div className="container">
            <div className="about-info__users-title">
              платформой Учи.ру пользуются
            </div>
            <ul className="about-info__users-number users-number">
              <li className="users-number__item">
                <div className="users-number__figure">12</div>
                <div className="users-number__text">млн <br className="optional-break-desktop"/>учеников</div>
              </li>
              <li className="users-number__item">
                <div className="users-number__figure">6</div>
                <div className="users-number__text">млн <br className="optional-break-desktop"/>родителей</div>
              </li>
              <li className="users-number__item">
                <div className="users-number__figure">800</div>
                <div className="users-number__text">тыс. <br className="optional-break-desktop"/>учителей</div>
              </li>
            </ul>
          </div>
        </div>
        <div className="about-info__motivation">
          <div className="container">
          <div className="about-info__motivation-description">
            Если ты любишь решать нетривиальные задачи, 
            экспериментировать и&nbsp;создавать продукты для&nbsp;миллионов пользователей — присоединяйся, 
            чтобы&nbsp;развивать школьный EdTech вместе с&nbsp;нами.
          </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Info;
